import React, {Component} from 'react'
import ItemQC from './ItemQC'
import PropTypes from "prop-types"

class ListItemsQCError extends Component {
    _toggleSelectAll = (e) => {
        const {checked} = e.target
        const {toggleSelectAll} = this.props

        toggleSelectAll(checked)
    }

    _cancelQC = (e) => {
        e.preventDefault()
        const {cancelQC} = this.props

        cancelQC()
    }

    _submitQC = (e) => {
        e.preventDefault()
        const {submitQC} = this.props

        submitQC()
    }

    render() {
        const {dataMarkError, arrChecked, updateOrdersSelected} = this.props

        return (
            <div>
                {dataMarkError.length > 0 && (
                    <div className="listDataQC row">
                        {dataMarkError.map(item => {
                            return (
                                <div key={item.order._id} className="col-sm-3 mt-3">
                                    <div className="itemQC">
                                        <ItemQC
                                            item={item.order}
                                            arrChecked={arrChecked}
                                            updateOrdersSelected={updateOrdersSelected}
                                            />
                                        <div className="text-danger fontSize20 mt-2"><strong>Lỗi</strong>: {item.message}</div>
                                    </div>
                                </div>
                            )
                        })}
                        <div className="foot d-flex align-items-center justify-content-between w-100 mt-4 col-12">
                            <button type="button" onClick={this._cancelQC} className="btn btn-outline-secondary">Đóng </button>
                        </div>
                    </div>
                )}
            </div>
        )
    }
}

ListItemsQCError.propTypes = {
    dataMarkError: PropTypes.array.isRequired,
    arrChecked: PropTypes.array,
    updateOrdersSelected: PropTypes.func.isRequired,
    toggleSelectAll: PropTypes.func.isRequired,
    loading: PropTypes.bool.isRequired
}

export default ListItemsQCError